
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Avatar from 'components/Avatar';
import { getDarkerColor, rgbToHex } from 'utils/colors';
import {
  DeliverableCard, DeliverableTitle, DeliverableUser, UserAvatar, UserName,
  DeliverableImage, DeliverableDescription, LikeButton, CloseIcon, ShowNumber,
  SafeZone,
} from './styles';

class Deliverable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: props.element.like
    };
  }
  handleLike = () => {
    const { onLike, element: { id } } = this.props;
    const { selected } = this.state;
    onLike(id);

    if (selected) {
      this.setState({ selected: false });
    } else {
      this.setState({ selected: true });
    }
  }

  render() {
    const {
      element, color, onClose, showClose,
      total, position, showLike,
    } = this.props;

    const { selected } = this.state;

    const {
      name, image, description, like, label,
    } = element;
    const darkerColor = rgbToHex(getDarkerColor(color));

    return (
      <div>
        <DeliverableCard id='deliverable-card-body'>
          {showClose && (<CloseIcon className='fa fa-times' onClick={onClose} />) }
          {
            element.user && element.user.id && element.user.firstname ? (
              <DeliverableUser>
                <Avatar id={element.user.id} firstname={element.user.firstname} avatar={element.user.avatar} size={48} />
              </DeliverableUser>
            ) : null
          }
          {name && <DeliverableTitle>{name}</DeliverableTitle> }
          {label && <DeliverableTitle>{label}</DeliverableTitle> }
          {image && (
            <DeliverableImage image={image} />
          )}
          {description && (
            <DeliverableDescription>{description}</DeliverableDescription>
          )}
          <SafeZone>
            <ShowNumber backgroundColor={color.color || color}>{`${position + 1}/${total}`}</ShowNumber>
          </SafeZone>
        </DeliverableCard>
        { showLike && (
          <LikeButton className={selected ? 'like' : ''} color={color} onClick={this.handleLike}>
            <i className='fa fa-check' />
          </LikeButton>)
        }
      </div>
    );
  }
}

Deliverable.propTypes = {
  element: PropTypes.object.isRequired,
  color: PropTypes.string.isRequired,
  onLike: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  showClose: PropTypes.bool,
  total: PropTypes.number.isRequired,
  position: PropTypes.number.isRequired,
  showLike: PropTypes.bool,
};
Deliverable.defaultProps = {
  onClose: null,
  showClose: false,
  showLike: true,
};

export default Deliverable;



// WEBPACK FOOTER //
// ./src/components/Steps/Deliverables/components/Deliverable.jsx